export const pushToWeborama = (type: string, value: string) => {
    checkWamf(function () {
        window.wamf?.push(type, value);
        window.wamf?.send();
    });
};
function checkWamf(callback: () => void) {
    let check = function () {
        if (typeof window !== 'undefined') {
            callback();
        }
        else {
            setTimeout(check, 500);
        }
    };
    setTimeout(check, 500);
}
